import React from "react";
import { logo } from "../assets";
function Reports() {
  return (
    <>
      <div className="min-h-screen  p-3  md:px-20 lg:px-32 ">
        <img
          src={logo}
          alt=""
          className="absolute -z-10 top-[50%] left-[50%] transform -translate-x-[50%] -translate-y-[50%] opacity-5"
        />
        <div className="">
          <h1 className="text-3xl my-3  font-semibold text-green">
            ಇತ್ತೀಚಿನ ವರದಿಗಳು
          </h1>
          <p className="text-2xl font-semibold">
            ಗೂಗಲ್ ಮೀಟ್ ಮುಖೇನ ಸಂಘದ ಸದಸ್ಯರಿಗೆ ಕಲಿಕೆ ಕಾರ್ಯಾಗಾರಗಳು.
          </p>
          <p className="lg:text-xl md:text-2xl md:leading-8">
            <ul className="list-disc ml-5">
              <li>
                <span className="font-semibold">ಜುಲೈ ೩೧:</span> ಆಟೋಕ್ಯಾಡ್ ನಲ್ಲಿ
                ಜಿಯೋರೆಫರೆನ್ಸಿಂಗ್ ಮಾಡುವ ವಿಧಾನ.
              </li>
              <li>
                <span className="font-semibold">ಆಗಷ್ಟ್ ೬:</span> ಅಳೆಗೆ ಸಂಭಂಧಿಸಿದ
                ಕಾನೂನುಗಳ ಬಗ್ಗೆ ಚರ್ಚೆ.
              </li>
              <li>
                <span className="font-semibold">ಆಗಷ್ಟ್ ೧೩:</span> ಟೋಟಲ್ ಸ್ಟೇಷನ್
                ಪರಿಚಯ
              </li>
              <li>
                <span className="font-semibold">ಆಗಷ್ಟ್ ೨೦:</span> ಟೋಟಲ್ ಸ್ಟೇಷನ್
                ಪರಿಚಯ
              </li>
              <li>
                <span className="font-semibold">ಆಗಷ್ಟ್ ೨೮:</span> ಆಟೋಕ್ಯಾಡ್
              </li>
              <li>
                <span className="font-semibold">ಸೆಪ್ಟೆಂಬರ್ ೩:</span> ಇ.ಟಿ.ಎಸ್
                ನಲ್ಲಿ ಡಾಟಾ ಕಲೆಕ್ಡ್ ಮಾಡುವ ಬಗೆ.
              </li>
              <li>
                <span className="font-semibold">ಸೆಪ್ಟೆಂಬರ್ ೧೦:</span> ಕಲೆಕ್ಟ್ ಆದ
                ಡಾಟಾವನ್ನು ಇಂಪೋರ್ಟ್ ಮಾಡುವುದು.
              </li>
              <li>
                <span className="font-semibold">ಸೆಪ್ಟೆಂಬರ್ ೧೭:</span> ಇಂಪೋರ್ಟ್
                ಆದ ಡಾಟಾವನ್ನು ಜಿಯೋರೆಫರೆನ್ಸಿಂಗ್ ಮಾಡುವುದು.
              </li>
              <li>
                <span className="font-semibold">ಸೆಪ್ಟೆಂಬರ್ ೨೪:</span> ಇ.ಟಿ.ಎಸ್
                ಸಹಾಯದಿಂದ ಹದ್ದುಬಸ್ತು ಮಾಡುವ ವಿಧಾನ
              </li>
              <li>
                <span className="font-semibold">ಅಕ್ಟೋಬರ್ ೧:</span> ಟೋಟಲ್ ಸ್ಟೇಷನ್
                ಮುಂದುವರಿದ ಬಾಗ.
              </li>
              <li>
                <span className="font-semibold">ಅಕ್ಟೋಬರ್ ೮:</span> ಜಿ.ಐ.ಎಸ್
                ಆರ್ಕ್ ಮ್ಯಾಪ್ ಸಾಫ್ಟ್ವೇರ್ ನ ಕಾರ್ಯಾಗಾರ ಇದ್ದು ಸದಸ್ಯರು ಭಾಗವಹಿಸದ ಕಾರಣ
                ಕಾರ್ಯಾಗಾರವನ್ನು ನಿಲ್ಲಿಸಲಾಯಿತು
              </li>
              <li>
                <span className="font-semibold">ಏಪ್ರಿಲ್ ೨೨:</span> ಪ್ರತಿದಿನ
                ರಾತ್ರಿ ಸ್ಪರ್ಧಾತ್ಮಕ ಪರೀಕ್ಷೆಗಳಿಗೆ ತಯಾರಾಗುವ ಉದ್ದೇಶದಿಂದ{" "}
                <span className="underline underline-offset-2">
                  ಪ್ರತಿ ದಿನ ಒಂದು ಗಂಟೆ, ಒಂದು ವಿಷಯ, ಒಂದು ಚರ್ಚೆ
                </span>{" "}
                ಆಧಾರದ ಮೇಲೆ ಪ್ರತಿದಿನ ರಾತ್ರಿ ೦೯:೦೦ ರಿಂದ ೧೦:೦೦ ರ ವರೆಗೆ ತರಬೇತಿ
                ಕಾರ್ಯಾಗಾರಗಳನ್ನು ನಡೆಸಲಾಗುತ್ತಿದೆ.
              </li>
            </ul>
          </p>
        </div>
      </div>
    </>
  );
}

export default Reports;
